<!--begin::Topbar-->
<ng-container *ngIf="extrasQuickPanelDisplay">
  <!--begin::Quick panel-->
  <!--<div class="topbar-item" style="vertical-align: middle !important;">
    <div class="btn btn-icon btn-clean btn-lg mr-1" id="kt_quick_panel_toggle">
      <span [inlineSVG]="'./assets/media/svg/icons/Layout/Layout-4-blocks.svg'" cacheSVG="true"
        class="svg-icon svg-icon-xl svg-icon-primary"></span>
    </div>
  </div>-->
  <!--end::Quick panel-->
</ng-container>

<!-- <ng-container *ngIf="extrasLanguagesDisplay">
  <app-language-selector style="margin-top: 10px;"></app-language-selector>
</ng-container> -->

<ng-container *ngIf="extrasUserDisplay">
  <ng-container *ngIf="extrasUserLayout === 'offcanvas'">
    <!-- <ng-container *ngIf="userData"> -->
      <!--begin::User-->
      <div class="topbar-item">
        <div class="btn btn-icon btn-icon-mobile w-auto btn-clean d-flex align-items-center btn-lg px-2"
          id="kt_quick_user_toggle">
          <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
          <span
            class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">{{ userData?.firstName ? userData?.firstName : userData?.lastName }}</span>
          <span class="symbol symbol-lg-35 symbol-25 symbol-light-success">
            <span class="symbol-label font-size-h5 font-weight-bold">{{
              userData?.firstName ? userData?.firstName[0] : userData?.lastName[0]
            }}</span>
          </span>
        </div>
      </div>
      <!--end::User-->
    <!-- </ng-container> -->
  </ng-container>

  <ng-container *ngIf="extrasUserLayout === 'dropdown'">
    <!--begin::User-->
    <ng-container *ngIf="userData">
      <div class="dropdown" ngbDropdown placement="bottom-right">
        <div class="topbar-item" data-toggle="dropdown" data-offset="0px,0px" ngbDropdownToggle>
          <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
            <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
            <span
              class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">{{ userData?.firstName ? userData?.firstName : userData?.lastName }}</span>
            <span class="symbol symbol-35 symbol-light-success">
              <span class="symbol-label font-size-h5 font-weight-bold">{{
                userData?.firstName ? userData?.firstName : userData?.lastName
              }}</span>
            </span>
          </div>
        </div>
        <!--end::Toggle-->
        <!--begin::Dropdown-->
      </div>
      <!--end::Dropdown-->
    </ng-container>
    <!--end::User-->
  </ng-container>
</ng-container>
<!--end::Topbar-->
